import { Injectable } from '@angular/core';
import { Contract } from '@app/features/contracts/contract.model';
import { CdTDocument } from '@app/features/documents/document.model';
import { Layout } from '@app/nav/layout/layouts.model';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private contractSubject = new BehaviorSubject<Contract | undefined>(undefined);
  private layoutSubject = new BehaviorSubject<Layout>('panel-left');
  private documentSubject = new BehaviorSubject<CdTDocument | null>(null);
  private componentTypeSubject = new BehaviorSubject<'embauche' | 'social-security' | null>(null);

  readonly elements$: Observable<unknown[]> = combineLatest([this.contract$, this.document$]).pipe(
    map(([contract, document]) => {
      return [contract, document].filter((el) => el !== null && el !== undefined);
    }),
  );

  get layout$() {
    return this.layoutSubject.asObservable();
  }

  setLayout(layout: Layout) {
    this.layoutSubject.next(layout);
  }

  get contract$() {
    return this.contractSubject.asObservable();
  }

  setContract(contract: Contract | undefined) {
    this.contractSubject.next(contract);
    this.setLayout('panel-left');
    this.setComponentType(contract ? 'embauche' : null);
  }

  get componentType$() {
    return this.componentTypeSubject.asObservable();
  }

  setComponentType(type: 'embauche' | 'social-security' | null) {
    this.componentTypeSubject.next(type);
  }

  setSocialSecurity(contract: Contract | undefined) {
    this.setComponentType('social-security');
    this.setLayout('panel-left');
    this.contractSubject.next(contract);
  }

  get document$() {
    return this.documentSubject.asObservable();
  }

  /**
   * Ouvre la visionneuse sur un document, ou la ferme. Elle s'ouvre sans attendre le fichier :
   * c'est elle qui le charge, et qui dit qu'il charge ou pourquoi il ne s'affiche pas.
   */
  previewDocument(document: CdTDocument | null) {
    this.documentSubject.next(document);
  }
}
